// extracted by mini-css-extract-plugin
export default {"label":"SelectType_label__Dbq1f","select":"SelectType_select__CNV34","selectError":"SelectType_selectError__uSXN6"};